import { BrowserRouter } from 'react-router-dom';
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import AppRoutes from './routes';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import ReactQueryProvider from './providers/query-client-provider';
import { Analytics } from '@vercel/analytics/react';


export default function MainAppEntry(): JSX.Element {
    return (
        <BrowserRouter>
            <ReactQueryProvider>
                <MantineProvider>
                    <Notifications />
                    <ModalsProvider>
                        <AppRoutes />
                    </ModalsProvider>
                </MantineProvider>
            </ReactQueryProvider>
            <Analytics />
        </BrowserRouter>
    );
};
